import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const updateTrialDocument = async ({ documentId, name, description }) => {
  const token = localStorage.getItem("token");

  const res = await axios.patch(
    `${__API_URL__}/api/photos/documents/${documentId}/`,
    { name, description },
    { headers: { Authorization: `Token ${token}` } }
  );
  return res.data;
};

const useUpdateTrialDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTrialDocument,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["trial-documents", trialId] });
      toast.success("Document updated successfully");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to update document");
    },
  });
};

export default useUpdateTrialDocumentMutation;
